import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Our wardrobe is niche and high-value. Is a generic inventory tool not enough?",
    a: "Generic asset tools weren't designed for couture. Wardrobe Index is built around fashion-specific fields (brand, fabric, size, condition, season), couture vs ready-to-wear workflows, look pulls for fittings and shoots, and the unique movement patterns of a working wardrobe — pulled, fitted, returned, archived. That context is the product.",
  },
  {
    q: "How long does setup actually take?",
    a: "Most teams have their working rack catalogued in an afternoon. Bulk photo upload, custom-field templates per client, and a CSV import path (on the Phase-2 roadmap) make it realistic to onboard a 1,000-piece archive within the first week — without pausing your shoots.",
  },
  {
    q: "How do you protect our client data? Some of our clients are public figures.",
    a: "All data is encrypted at rest and in transit. Role-based access controls separate owners, full-time staff, and assistants. Every meaningful action — a pull, a return, a deletion — is captured in an immutable audit log. SOC 2 Type II is on our roadmap.",
  },
  {
    q: "We already use spreadsheets, Airtable, or a general asset manager. Why switch?",
    a: "Because none of those were designed for styling pulls, fittings, returns, or movement history across multiple physical locations. Wardrobe Index gives you the single source of truth your assistants, your client, and (eventually) your insurer all need — without you maintaining the schema.",
  },
  {
    q: "Does this work for a solo stylist or only for studios?",
    a: "Both. Starter is sized for a single stylist managing one or two clients out of one studio. Pro is built for teams handling multiple clients across racks, bins, archives, and residences — with loan tracking, lookbooks, and reporting your insurer will actually accept.",
  },
];

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      aria-labelledby="faq-heading"
      className="py-20 md:py-28 border-t border-border"
    >
      <div className="max-w-[1100px] mx-auto px-6 md:px-12">
        <div className="md:grid md:grid-cols-12 md:gap-12">
          <div className="md:col-span-4 mb-12 md:mb-0">
            <p className="text-[11px] uppercase tracking-[0.28em] text-oxblood font-medium mb-5">
              — Real objections
            </p>
            <h2
              id="faq-heading"
              className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] text-balance"
            >
              The questions you'd ask a friend over coffee.
            </h2>
            <p className="mt-5 text-sm md:text-base text-muted-foreground">
              We get these every week. Answers in plain language — no SaaS
              boilerplate.
            </p>
          </div>

          <div className="md:col-span-8">
            <Accordion
              type="single"
              collapsible
              defaultValue="faq-0"
              data-testid="faq-accordion"
              className="w-full"
            >
              {faqs.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`faq-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-border"
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="font-display text-left text-lg md:text-xl py-6 hover:no-underline hover:text-oxblood transition-colors"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-content-${i}`}
                    className="text-sm md:text-base text-muted-foreground leading-relaxed pb-6 max-w-prose"
                  >
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
